import { c as _c } from "react/compiler-runtime";
import useFormErrorMessage from '@/form/ActionForm/useFormErrorMessage';
import { ErrorMessageText } from '@/form/ErrorMessage';
type Props = {
  className?: string;
  incompleteMessage: string;
  // only relevant for IBANs; the schema flags the country but can't translate, so the message comes from here
  invalidCountryMessage?: string;
};

// Stripe fields can be invalid for several reasons at once, but only the most relevant one is shown
function StripeFieldErrorMessage(t0) {
  const $ = _c(9);
  const {
    className,
    incompleteMessage,
    invalidCountryMessage
  } = t0;
  const countryError = useFormErrorMessage("_stripe_iban_country");
  const stripeError = useFormErrorMessage("stripe_token");
  const incompleteError = useFormErrorMessage("_stripe_complete");
  if (countryError && invalidCountryMessage) {
    let t1;
    if ($[0] !== className || $[1] !== invalidCountryMessage) {
      t1 = <ErrorMessageText name="_stripe_iban_country" className={className}>{invalidCountryMessage}</ErrorMessageText>;
      $[0] = className;
      $[1] = invalidCountryMessage;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (stripeError) {
    let t1;
    if ($[3] !== className || $[4] !== stripeError) {
      t1 = <ErrorMessageText name="stripe_token" className={className}>{stripeError}</ErrorMessageText>;
      $[3] = className;
      $[4] = stripeError;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  if (incompleteError) {
    let t1;
    if ($[6] !== className || $[7] !== incompleteMessage) {
      t1 = <ErrorMessageText name="_stripe_complete" className={className}>{incompleteMessage}</ErrorMessageText>;
      $[6] = className;
      $[7] = incompleteMessage;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    return t1;
  }
}
export default StripeFieldErrorMessage;